import React from "react";

export interface TraceStepperContextType {
    activeStep?: unknown;
}

export const TraceStepperContext = React.createContext<TraceStepperContextType>({});
